import {
	GET_CPT_CODES,
	GET_CPT_CODES_SUCCESS,
	GET_CPT_CODES_FAIL,
	GET_CPT_CODES_RESET,
} from '../actions/getCptCodesAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getCptCodesReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_CPT_CODES:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_CPT_CODES_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_CPT_CODES_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_CPT_CODES_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getCptCodesReducer;
